import { createContext, useContext, useState, useCallback, ReactNode, useEffect } from 'react';
import { Log } from '@/services/saas-dispute/logs/index.d';
import { getLogList } from '@/services/saas-dispute/logs';
import { useParams } from '@umijs/max';
import { useLocalStorageState } from 'ahooks';
// Context 类型定义
interface LogsContextType {
  // 状态
  logs: Log[];
  loading: boolean;
  error: string | null;
  isLogsOpen: boolean;

  clearLogs: () => void;
  setIsLogsOpen: (isLogsOpen: boolean) => void;
}
// 本地存储的key
export const SAAS_LOGS_OPEN = 'saas_logs_open';
// 创建 Context
const LogsContext = createContext<LogsContextType | undefined>(undefined);

// Provider Props 类型
interface LogsProviderProps {
  children: ReactNode;
}

// Provider 组件
export const LogsProvider: React.FC<LogsProviderProps> = ({
  children,
}) => {
  // 状态管理
  const [logs, setLogs] = useState<Log[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLogsOpen, setIsLogsOpen] = useLocalStorageState(SAAS_LOGS_OPEN, { defaultValue: false });

  // 清空日志
  const clearLogs = useCallback(() => {
    setLogs([]);
    setError(null);
  }, []);

  // Context 值
  const contextValue: LogsContextType = {
    // 状态
    logs,
    loading,
    error,
    isLogsOpen: isLogsOpen || false,
    setIsLogsOpen,
    clearLogs
  };

  return (
    <LogsContext.Provider value={contextValue}>
      {children}
    </LogsContext.Provider>
  );
};

// 自定义 Hook
export const useLogs = (): LogsContextType => {
  const context = useContext(LogsContext);

  if (context === undefined) {
    throw new Error('useLogs must be used within a LogsProvider');
  }

  return context;
};

export { LogsContext };
